import React from "react";
import styled from "styled-components";
import { Input } from "../../../../Input/Input";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface UplusMatchingStatusResultModalProps extends DefaultModalCommonProps {
  successCnt?: number;
  failCnt?: number;
}

export default function UplusMatchingStatusResultModal({
  closeEvent,
  confirmEvent,
  successCnt,
  failCnt,
}: UplusMatchingStatusResultModalProps) {
  return (
    <DefaultModalLayout
      modalTitle="결합 상태 변경 결과"
      isSmallModal={true}
      closeEvent={() => closeEvent()}
      cancelBtn={<></>}
      confirmEvent={() => {
        if (confirmEvent) confirmEvent();
      }}
    >
      <ModalRow>
        <ModalLabel>변경 성공</ModalLabel>

        <Input value={`${successCnt ?? 0}명`} readOnly={true} />
      </ModalRow>

      <>
        {failCnt! > 0 && (
          <ModalRow style={{ alignItems: "flex-start" }}>
            <ModalLabel>실패(중복)</ModalLabel>

            <div>
              <Input value={`${failCnt ?? 0}명`} readOnly={true} />

              <AddDesc>* 실패(중복): 이미 결합 상태가 변경된 고객</AddDesc>
            </div>
          </ModalRow>
        )}
      </>
    </DefaultModalLayout>
  );
}

const AddDesc = styled.div`
  margin-top: 12px;
  font-size: 14px;
  line-height: 21px;
  text-align: left;
  color: #858c97;
`;
